import { z } from 'zod';

export const EpmMasterFunctionality = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  enabled: z.boolean().default(false),
  sortOrder: z.number().int().default(1),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
  usageStats: z
    .object({
      employeeAllocationCount: z.number().default(0),
    })
    .optional(),
});
export type EpmMasterFunctionalityType = z.infer<typeof EpmMasterFunctionality>;
